import { Thumbnail } from './components/Thumbnail'
import { Ticket } from './components/Ticket'
import { TicketList } from './components/TicketList'

export const SupportClient = {
  Ticket,
  TicketList,
  Thumbnail,
}
